<nz-alert
    *ngIf="cancellationStatus$ | async as status"
    nzShowIcon
    nzType="warning"
    [nzDescription]="alertDescriptionTmpl"
>
    <ng-template #alertDescriptionTmpl>
        <div class="a-fx a-fx-between-center a-fx-gap-32">
            <div class="a-fx-col a-fx-gap-8 a-fx-flex">
                <div class="h3">
                    {{ 'common.subscription.no-active' | translate }}
                </div>

                <div
                    [innerHTML]="
                        message$ | async | translate: { date: cancellationDate$ | async | formatDate: 'dd MMM, yyyy' }
                    "
                ></div>
            </div>

            <button
                *ngIf="action$ | async as action"
                nz-button
                nzType="primary"
                class="a-fx-none"
                [nzLoading]="action.loading ? (action.loading | async) : false"
                (click)="action.handler(status)"
            >
                {{ action.label | translate }}
            </button>
        </div>
    </ng-template>
</nz-alert>
